import { OriginalPicker } from '@/src/components/Antd';
import _ from 'lodash';
import React, { useEffect, useState } from 'react';
import GlobalPagination from '../../components/StyledPagination/GlobalPagination';
import css from './GlobalTable.less';

import _Query, { EnumQueryType } from 'src/constrains/Query1';

import BulkEditor from '@/src/components/BulkEditor/BulkEditor';
import Table from '@/src/components/EditableTable/EditableTable';
import Selector from 'src/components/TableColSelector/ColSelector';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
const { RangePicker } = OriginalPicker;
interface IProps {
  columns;
  dataSource;
  pagination?;
  id: string;
  onRow?: any;
  hideHeader?: boolean; //不展示table上方的设置和多选展示及批量操作
  hideRowSelection?: boolean;
  hidePagination?: boolean;
  disableSelectButton?: boolean; //是否隐藏Bulk Edit按钮
  buttonMenu?; //配置Bulk Edit
  expandable?;
  current?;
  pageSize?;
  setCurrent?;
  setPageSize?;
  total?;
  rowKey?;
  setSelectedAll?;
  // rowSelection?;
  rowSelection?;
  selectedRowKeys?;
  mappedSelectedKeys?;
  loading?;
  queryProps?;
  allProductsUuid?;
  hideQuery?;
  addFun?;
  addText?;
  rowDeleteFunc?;
  selectedAll?;
  className?;
  totalText?: string;
  onTableChange?: string;
  handleTableSettingChange?; //redux中保存的配置table columns的action,如不需缓存则不需要传
  tableSettings?; //redux中保存的配置table columns的key,不传则默认为展示state中的数据
  onColChange?;
  displayCol?;
  colsFromParent?: boolean;
  showSorterTooltip?: boolean;
  onChange?;
  hideBulkEditor?: boolean;
  showTimePicker?: boolean;
  bulkEditText?: string;
  timePickerValue?;
  timePickerOnChange?;
  holdHeader?; //一直展示Table的header
}
const GlobalTable = (props: IProps) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const BEGIN_PLACEHOLDER = getI18n('general.startdate');
  const END_PLACEHOLDER = getI18n('general.enddate');
  const {
    columns, //宽度和minWidth不能用%！
    dataSource,
    // disableSelectButton,
    buttonMenu,
    pagination = {},
    id,
    hideRowSelection,
    hideHeader,
    hidePagination,
    expandable,
    current,
    pageSize,
    setCurrent,
    setPageSize,
    total,
    loading,
    rowKey,
    rowSelection = {},
    selectedRowKeys,
    //mappedSelectedKeys,
    queryProps = {},

    hideQuery,
    totalText,
    selectedAll,
    setSelectedAll,
    className,
    // handleTableSettingChange,
    colsFromParent,
    onColChange,
    hideBulkEditor,
    showTimePicker,
    bulkEditText,
    timePickerValue,
    timePickerOnChange,
    holdHeader,
    ...rest
  } = props;

  const [_allColumns, setAllColumns] = useState(columns || []);
  const allColumns = colsFromParent ? columns : _allColumns;
  // const allColumns = colsFromParent?
  //  React.useEffect(() => {
  //    if (displayCol && displayCol !== allColumns) {
  //      setAllColumns(displayCol);
  //    }
  //  }, [displayCol]);
  const handleOnDisplayColChange = (col) => {
    //  console.log('col', col);
    if (onColChange) {
      onColChange(col);
    }
    if (!colsFromParent) setAllColumns(col);
  };
  useEffect(() => {
    const columnArray = _.cloneDeep(columns || []);
    if (!colsFromParent) {
      handleOnDisplayColChange(columnArray);
    }
  }, [columns]);

  // const saveColumns = (tableSettings || []).length
  //   ? allColumns.map((o) => {
  //       if (tableSettings.includes(o.key)) {
  //         o.default = true;
  //       } else {
  //         o.default = false;
  //       }
  //       return o;
  //     })
  //   : [];
  const showSet = allColumns.filter((column) => column.optional); //显示在下拉框里面的选项，col

  const _handleOnColChange = (columnArray) => {
    handleOnDisplayColChange(columnArray);
    // const allColumnsKey = columnArray.map((column) => {
    //   if (column.default) {
    //     return column.key;
    //   }
    // });
    // if (handleTableSettingChange) handleTableSettingChange(allColumnsKey);
  };

  const handleOnColChange = (col = []) => {
    _handleOnColChange(col);
  };
  const pageOnChange = (page, pageSize) => {
    setCurrent(page - 1);
  };
  const pageSizeChange = (value) => {
    setPageSize(value.value);
    setCurrent(0);
  };

  //选择全部
  const selectAll = () => {
    //TODO:选择全部待确认，是否需要从后端拿到全部的uuid
    const allSelect = dataSource.map((item) => {
      return item.uuid;
    });
    if (setSelectedAll) setSelectedAll(true);
    rowSelection.onChange(allSelect);
  };
  //重置设置
  const setReset = () => {
    _handleOnColChange(columns);
  };
  //配置每页展示条数
  const pageSizeOption = [20, 60, 100];

  const handleOnSearchChange = (e) => {
    if (queryProps.onSearchChange) {
      queryProps.onSearchChange({ search: e, type: EnumQueryType.search });
    }
  };

  const handleOnFilterChange = (e) => {
    if (queryProps.onSearchChange) {
      queryProps.onSearchChange({ filter: e, type: EnumQueryType.filter });
    }
  };

  const handleOnSortChange = (e) => {
    if (queryProps.onSearchChange) {
      queryProps.onSearchChange({ sort: e, type: EnumQueryType.sort });
    }
  };

  const handleOnSearchClose = (e) => {
    if (queryProps.onSearchChange) {
      queryProps.onSearchChange({ item: e, type: EnumQueryType.closeTag });
    }
  };

  return (
    <React.Fragment>
      {/* {!hideQuery && <Query {...queryProps} />} */}
      {!hideQuery && (
        <div className={css.queryContainer}>
          <_Query
            onSearchChange={handleOnSearchChange}
            onFilterChange={handleOnFilterChange}
            onSortChange={handleOnSortChange}
            onTagClose={handleOnSearchClose}
            filters={queryProps.filters || []}
            sortList={queryProps.sortList || []}
            data={queryProps.searchConditions || []}
          />
        </div>
      )}
      {/* {(queryProps.searchListArray.length > 0 ||
        queryProps.filter.length > 0) &&
        !dataSource.length && <TableNoData />} */}
      {(dataSource.length && !hideHeader) || holdHeader ? (
        <div className={css.tableHeader}>
          {!hideBulkEditor ? (
            <BulkEditor
              selectAll={selectAll}
              selectedAll={selectedAll}
              buttonMenu={buttonMenu}
              total={total}
              dataSource={dataSource}
              bulkEditText={bulkEditText}
              selectedRowKeys={selectedRowKeys} //mappedSelectedKeys}
              hideSelectAll={hideRowSelection}
              //allSelected={mappedSelectedKeys}
            />
          ) : (
            <div />
          )}

          <div className={css.tableHeaderRight}>
            {showTimePicker && (
              <RangePicker
                className={css.rangePicker}
                value={timePickerValue}
                placeholder={[BEGIN_PLACEHOLDER, END_PLACEHOLDER]}
                onChange={timePickerOnChange}
                size='small'
              />
            )}
            {showSet.length > 0 && (
              <Selector
                allColumns={allColumns}
                onChange={handleOnColChange}
                setReset={setReset}
              />
            )}
          </div>
        </div>
      ) : (
        ''
      )}

      <Table
        id={id}
        // className={css.globalTable}
        columns={allColumns}
        dataSource={dataSource}
        className={className}
        rowKey={rowKey}
        pagination={false}
        expandable={expandable}
        {...(!hideRowSelection && { rowSelection })}
        loading={loading}
        {...rest}
      />

      {!hidePagination ? (
        <GlobalPagination
          pageOnChange={pageOnChange}
          totalText={totalText}
          pageSize={pageSize}
          pageSizeOption={pageSizeOption}
          pageSizeChange={pageSizeChange}
          total={total}
          current={current + 1}
          paginationProps={pagination}
          pageSizeWidth={120}
          setCurrent={setCurrent}
        />
      ) : (
        ''
      )}
    </React.Fragment>
  );
};
export default GlobalTable;
